import React, { useState } from 'react';
import {
  Box,
  Grid,
  ToggleButton,
  ToggleButtonGroup,
  Typography,
} from '@mui/material';
import CardHeader from '../shared/CardHeader';
import CardContainer from '../shared/CardContainer';
import { BarChart as MuiBarChart } from '@mui/x-charts';
import { dataVisColors } from '@mercedes-benz/mui5-theme';
import { useTheme } from '@mui/material';
import {
  DirectionsBoatFilledOutlined,
  DirectionsCarFilledOutlined,
} from '@mui/icons-material';
import { formatNumberDE } from '../../../../../../shared/utils/formatNumber';

const BarChart = ({ title = 'N/A', subtitle = 'N/A', data = {} }) => {
  const [dataType, setDataType] = useState('Cars'); // State to track the current data type
  const theme = useTheme();
  const themeType = theme.palette.mode === 'light' ? 'light' : 'dark';
  const colorScheme = dataVisColors.basic[themeType];
  const valueFormatter = (value) =>
    `${formatNumberDE(value)} ${dataType === 'Ships' ? 'Voyages' : dataType}`; // Define a value formatter based on the data type

  // Handle filter changes
  const handleFilterChange = (key, value) => {
    if (key === 'dataType') {
      setDataType(value);
    }
  };

  // Process dataset based on the selected data type
  const processedDataset = data.map((item) => {
    const newItem = { month: item.month };
    Object.keys(item).forEach((key) => {
      if (key !== 'month') {
        if (dataType === 'Cars' && key.endsWith('_Cars')) {
          newItem[key.replace('_Cars', '')] = item[key];
        } else if (dataType === 'Ships' && key.endsWith('_Ships')) {
          newItem[key.replace('_Ships', '')] = item[key];
        }
      }
    });
    return newItem;
  });

  return (
    <CardContainer>
      <Grid container spacing={0}>
        <Grid item xs={6}>
          <CardHeader title={title} />
        </Grid>
        <Grid item xs={6} sx={{ textAlign: 'right' }}>
          <ToggleButtonGroup
            color='primary'
            value={dataType}
            exclusive
            onChange={(event, newDataType) =>
              handleFilterChange('dataType', newDataType)
            }
            aria-label='Data Type'
            sx={{ marginBottom: '20px' }}
          >
            <ToggleButton value='Cars'>
              <DirectionsCarFilledOutlined />
            </ToggleButton>
            <ToggleButton value='Ships'>
              <DirectionsBoatFilledOutlined />
            </ToggleButton>
          </ToggleButtonGroup>
        </Grid>
      </Grid>
      <Box padding={'10px'}>
        <Typography variant='h6'>{subtitle}</Typography>
        {processedDataset.length > 0 ? (
          <MuiBarChart
            height={364}
            dataset={processedDataset}
            xAxis={[{ scaleType: 'band', dataKey: 'month' }]}
            yAxis={[{ valueFormatter: formatNumberDE }]}
            colors={colorScheme}
            series={Object.keys(processedDataset[0])
              .filter((key) => key !== 'month')
              .map((key) => ({
                dataKey: key,
                label: key,
                valueFormatter,
              }))}
          />
        ) : (
          <Typography>No data available for {subtitle}</Typography>
        )}
      </Box>
    </CardContainer>
  );
};

export default BarChart;
